<template>
  <div>
    <custom-actions show-back>
      <el-form
        class="form"
        :model="form"
        :rules="rules"
        ref="form"
        label-width="140px"
      >
        <el-form-item label="类型名称" prop="oilTypeName">
          <el-input v-model="form.oilTypeName" placeholder="请输入类型名称" />
        </el-form-item>
        <el-form-item label="规格" prop="oilSpecs">
          <el-input v-model="form.oilSpecs" placeholder="请输入规格" />
        </el-form-item>
        <el-form-item label="单位" prop="ygUnit">
          <el-select v-model="form.ygUnit" filterable>
            <el-option
              :value="item.dicCode"
              :label="item.dicValue"
              v-for="(item, index) of unitList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="图片" prop="oilImg">
          <div style="display: flex">
            <el-image
              v-if="form.oilImg"
              style="
                width: 150px;
                height: 150px;
                margin-right: 10px;
                border: 1px solid #eee;
              "
              :src="form.oilImg"
              :preview-src-list="[form.oilImg]"
            >
            </el-image>
            <el-upload
              class="upload-demo"
              :action="$apis.common.uploadUrl"
              list-type="picture-card"
              :on-success="handleSuccess"
              :before-upload="beforeUpload"
              accept="image/*"
              :multiple='false'
              :show-file-list="false"
            >
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">
                只能上传一个图片且大小不能超过10MB~
              </div>
            </el-upload>
          </div>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="submit" class="global-button"
            >保存</el-button
          >
          <el-button @click="$router.back()" class="global-button"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </custom-actions>
  </div>
</template>

<script>
export default {
  name: 'CpyCategoryAdd',
  data () {
    return {
      unitList: [],
      form: {
        oilTypeName: '',
        oilImg: '',
        oilSpecs: '',
        ygUnit: ''

      },
      rules: {
        oilTypeName: [{ required: true, message: '请输入类型名称', trigger: ['change', 'blur'] }],
        oilSpecs: [{ required: true, message: '请输入规格', trigger: ['change', 'blur'] }],
        oilImg: [{ required: true, message: '请上传图片', trigger: ['change', 'blur'] }],

        ygUnit: [{ required: true, message: '请选择单位', trigger: 'change' }]

      }
    }
  },
  computed: {
    oilType () {
      return this.$route.query.oilType
    }

  },
  created () {
    this.loadType()

    if (this.oilType) {
      this.loadDetails()
    }
  },
  methods: {

    handleSuccess (res) {
      console.log('res: ', res)
      this.form.oilImg = ''
      if (res) {
        const oilImg = res.data.filePrefix + res.data.fileUrl
        this.$set(this.form, 'oilImg', oilImg)
      }
      console.log('this.form.oilImg: ', this.form.oilImg)
      this.$nextTick(() => {
        this.$refs.form.validateField('oilImg')
      })
    },
    beforeUpload (file) {
      console.log('file: ', file)
      const isLt10M = file.size < (10 * 1024 * 1024)
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        this.$message.error('上传文件只能是图片格式!')
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!')
      }
      return isImage && isLt10M
    },

    loadType () {
      this.$axios.get(this.$apis.common.selectDicByList, {
        params: { dicType: 'ygUnit' }
      }).then(res => {
        this.unitList = res.ygUnit || []
      })
    },
    loadDetails () {
      this.$axios.get(this.$apis.oiltabkManage.selectYgOilTypeByOilType, {
        params: { oilType: this.oilType }
      }).then(res => {
        this.form = res || {}
      })
    },
    submit () {
      this.$refs.form.validate().then(() => {
        let url = this.$apis.oiltabkManage.insertYgOilType
        if (this.oilType) {
          url = this.$apis.oiltabkManage.updateYgOilType
        }
        this.$axios.post(url, this.form).then(res => {
          // this.$store.dispatch('getUserList')
          this.$router.back()
        })
      })
    },

    closeCascader () {
      this.$refs.cascader.dropDownVisible = false
    }

  }
}
</script>

<style scoped lang='scss'>
.del-btn {
  color: red;
}
.el-select,
.el-input,
.el-cascader {
  width: 400px;
}
</style>
